import { createFileRoute } from "@tanstack/react-router";
import { ComingSoonPage } from "@/components/layout/page-container.tsx";

export const Route = createFileRoute("/messages")({
  component: () => <ComingSoonPage title="系统消息" />,
});
